import React from 'react';
import AgencyNavbar from '../components/agencies/AgencyNavbar';
import Footer from '../components/layout/Footer';
import SafeIcon from '../common/SafeIcon';
import {
  AUTHORITY_BUILDER_LOGIN_URL,
  MOXIE_PARTNER_PORTAL_LOGIN_URL,
} from '../config/partnerAccess';

export default function PartnerAccess() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-[#F7F8F7] font-lexend text-[#101F1F]">
      <AgencyNavbar />

      <main className="px-5 pb-24 pt-32 sm:px-6 lg:px-8 lg:pb-32 lg:pt-40">
        <section className="mx-auto max-w-4xl">
          <div className="overflow-hidden rounded-3xl border border-[#244A49]/10 bg-white shadow-widget">
            <div className="bg-[#244A49] px-6 py-12 text-white sm:px-10 lg:px-14 lg:py-16">
              <p className="font-michroma text-[0.68rem] font-bold uppercase tracking-[0.2em] text-[#2CB5B0]">
                Partner Access
              </p>
              <h1 className="mt-5 text-balance text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
                Check your email.
              </h1>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-white/75">
                Moxie sends your secure portal invitation or magic link only
                after your contact has been granted partner portal access.
              </p>
            </div>

            <div className="px-6 py-10 sm:px-10 lg:px-14 lg:py-14">
              <div className="max-w-2xl">
                <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
                  Your first doorway is Moxie.
                </h2>
                <p className="mt-4 leading-7 text-[#244A49]/70">
                  Completing a website form does not create an account or send
                  a portal email. Once access is granted, use the invitation in
                  your inbox and then open the RepUpgrade Partner Portal.
                </p>
              </div>

              <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
                <a
                  href={MOXIE_PARTNER_PORTAL_LOGIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cta-glow inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-[#F49558] px-6 py-3 font-bold text-white shadow-cta transition hover:bg-[#D35E0E]"
                >
                  Open the RepUpgrade Partner Portal
                  <SafeIcon name="ArrowUpRight" className="h-5 w-5" />
                </a>
                <a
                  href={AUTHORITY_BUILDER_LOGIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-[#244A49]/20 bg-white px-6 py-3 font-bold text-[#244A49] transition hover:border-[#409FA1] hover:text-[#409FA1]"
                >
                  Client login
                  <SafeIcon name="ArrowUpRight" className="h-4 w-4" />
                </a>
              </div>

              <p className="mt-6 text-sm leading-6 text-[#244A49]/60">
                Client login opens the RepUpgrade product. Partner academy access
                will use a separate link, which is not ready yet.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}